<template>
  <div>
        <form-accordion v-if="type !== 'dbtr'" title="Transaction Details" :isTitleUpperCase="false">
          <b-row class="ml-5 mt-4 mb-4 mr-5 mr-5 form-group">
            <b-col sm="5">
              <label>Instant Credit Transfer</label>
              <b-form-checkbox v-model="changePassword" :checked="true">
                <span style="font-weight: normal;">Instant (SCT Inst)</span>
              </b-form-checkbox>
            </b-col>
            <b-col sm="5">
              <form-write-group-label-input
                inputLabel="Amount (€)" :value="85.40" isMandatory>
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <!-- <b-row class="ml-5 mt-4 mb-4 mr-5 mr-5 form-group">
            <b-col sm="5">
              <form-write-group-label-input
                inputLabel="Instruction Identification" value="PAY-2025-0045" isMandatory>
              </form-write-group-label-input>
            </b-col>
            <b-col sm="5">
              <form-write-group-label-input
                inputLabel="End-to-End Identification" value="EndToEndid00000000018" isMandatory>
              </form-write-group-label-input>
            </b-col>
          </b-row> -->
          <b-row class="ml-5 mt-4 mb-4 mr-5 mr-5 form-group">
            <b-col sm="5">
              <form-write-group-label-input
                inputLabel="Requested Execution Date" value="2025-10-11" isMandatory>
              </form-write-group-label-input>
            </b-col>
            <b-col sm="5">
              <form-write-group-label-input
                inputLabel="Remittance Information" value="Invoice #2025-0045 / Contract 987654">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row class="ml-5 mt-4 mb-4 mr-5 mr-5 form-group">
            <b-col sm="5">
              <form-write-group-label-input
                inputLabel="End-to-End Reference" value="EndToEndid00000000018" isMandatory>
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>
        <form-accordion v-if="type !== 'dbtr'" :title="$t('mandate.dbtr_info')" :isTitleUpperCase="false">
          <b-row class="ml-5 mt-4 mb-4 mr-5 mr-5 form-group">
            <b-col sm="5">
              <form-write-group-label-input
                :inputLabel="$t('mandate.dbtr_name')" :value="dbtr_name" isMandatory>
              </form-write-group-label-input>
            </b-col>
            <b-col sm="5">
              <form-write-group-label-input
                :inputLabel="$t('mandate.dbtr_iban')" :value="dbtr_iban">
              </form-write-group-label-input>
            </b-col>
          </b-row>
        </form-accordion>
        <b-row v-if="type !== 'dbtr'" class="form-group justify-content-end">
        <!--
        <b-col lg="2" offset-lg="8" v-if="hasRight('profil_edit')">
          <b-button variant="primary" size="lg"
            @click="editProfile">
            <i class="fa-light fa-pen-to-square" size="17px"></i>
            <span>{{ $t('profilesPage.edit_prfl') }}</span>
          </b-button>
        </b-col>
        -->
          <b-col sm="2">
            <b-button
              variant="primary">
              <i class="fa-light fa-paper-plane" size="17px"></i>
              <span>{{ $t('mandate.send') }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="type === 'dbtr'" class="form-group justify-content-end">

        <b-col lg="2" offset-lg="8">
          <b-button variant="primary" size="lg"
            @click="editProfile">
            <!-- <i class="fa-light fa-pen-to-square" size="17px"></i> -->
            <span>{{ $t('mandate.accept') }}</span>
          </b-button>
        </b-col>

          <b-col sm="2">
            <b-button
              variant="primary">
              <!-- <i class="fa-light fa-paper-plane" size="17px"></i> -->
              <span>{{ $t('mandate.refus') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
</template>

<script>
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'bottom-toolbar': bottomToolbar,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      active: 'one_off',
      active_sct: 1,
      cdtr_addrss: "12 Rue de la Finance",
      cdtr_city: "Paris",
      cdtr_ctry: "France",
      cdtr_iban: "FR76 3000 6000 0112 3456 7890 189",
      cdtr_id: "FR32ZZZ012345678200002",
      cdtr_name: "European Payment Bank",
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      ctr: "CTR-2025-857",
      dbtr_email: "john.dupont@gmail.com",
      dbtr_iban: "FR76 3000 6000 0112 3456 7890 189",
      dbtr_id: "FR32ZZZ012345678200005",
      dbtr_name: "John Dupont",
      rsn: "rsn",
      rum: "FR12ZZZ000000000123456-2025-00001"
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
    isCdtr() {
      return this.type === 'cdtr'
    },
    isDbtr() {
      return this.type === 'dbtr'
    },
    isDisabled() {
      return this.isDbtr
    }
  },
  methods: {
  }
}
</script>
